import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericResponse } from '../models/generic-response';
import { ChangePassword } from '../models/change-password.model';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailApiService {
  readonly #http = inject(HttpClient);

  readonly #url = environment.urlService;


  validateTokenToResetPassword(token: string) {
    const payload = {
      payload: {
        ruta: 'validaUrlToken',
        token
      },
      token
    }

    return this.#http.post<GenericResponse<null, null>>(`${this.#url}`, payload);
  }

  changePassword(value: ChangePassword): Observable<{ message: string }> {
    const firstLogin = value.firstLogin || false
    const payload = {
      payload: {
        ruta: 'updatePassword',
        updatePassword: {
          user: sessionStorage.getItem('idUsuario'),
          password: value.password,
          firstLogin,
          passwordAnterior: value.oldPassword,
          token: value.token
        }
      }
    }

    return this.#http.post<GenericResponse<string, null>>(`${this.#url}`, payload).pipe(
      map(({ responseObject }) => {
        sessionStorage.removeItem('firstLogin');
        return { message: responseObject }
      })
    )
  }
}
